export default ({ actionField = {}, products = [] }, userProfile, seatExitRow, pnrInfo) => {
  let clubpremierIDP = null;
  let balance = null;
  let metricPointsValue = 0;

  const {
    cart,
  } = pnrInfo;

  const {
    travelerCollection,
  } = cart;

  if (userProfile !== undefined && userProfile.ffNumber) {
    clubpremierIDP = userProfile.ffNumber;
    balance = userProfile.account.balance;

    if (seatExitRow !== undefined) {
      if (seatExitRow.redeemedCP === true) {
        metricPointsValue = seatExitRow.totalCPPoints;
      }
    }

    if (travelerCollection) {
      travelerCollection.map(travellerItem => {
        if (travellerItem && travellerItem.ancillaries && travellerItem.ancillaries.ancillaries) {
          travellerItem.ancillaries.ancillaries.map(ancillarieItem => {
            if (ancillarieItem && ancillarieItem.ancillary) {
              if (ancillarieItem.isPaid === false && ancillarieItem.ancillary.redeemedCP === true) {
                if (ancillarieItem.ancillary && ancillarieItem.ancillary.currency) {
                  metricPointsValue += ancillarieItem.ancillary.currency.totalCPPoints;
                }
              }
            }
          });
        }
      });
    }
  }

  return clubpremierIDP !== null ? {
    event: 'productClick',
    ticketNumber: '',
    pointsValue: metricPointsValue,
    pointsCP: balance,
    clubpremierIDP: clubpremierIDP,
    ecommerce: {
      click: {
        actionField,
        products,
      },
    },
  } : {
    event: 'productClick',
    ecommerce: {
      click: {
        actionField,
        products,
      },
    },
  };
};
